var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#047b08",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#047b08",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "b",
    x1: 0.286,
    x2: 22.98,
    y1: 9.982,
    y2: 9.982,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "c",
    x1: 0.286,
    x2: 22.98,
    y1: 12,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m19.275 5.275-7.293 7.293-2.275-2.275a.999.999 0 1 0-1.414 1.414l2.982 2.982a1 1 0 0 0 1.414 0l8-8a.999.999 0 1 0-1.414-1.414z",
    "data-original": "url(#b)",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M19 11a1 1 0 0 0-1 1c0 3.309-2.691 6-6 6s-6-2.691-6-6a6.006 6.006 0 0 1 8.559-5.429 1 1 0 1 0 .855-1.809A7.953 7.953 0 0 0 12 4c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8a1 1 0 0 0-1-1z",
    "data-original": "url(#c)",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/approve.dacaa81ad24e880fe337c318dade6a9e.svg";
export { ForwardRef as ReactComponent };